import React, { useState, useRef, useEffect } from "react";
import { RingLoader } from "react-spinners";
import styled from "styled-components";
import ImageSize from "./ImageSize";
import DropdownList from "react-widgets/DropdownList";
import ReactBeforeSliderComponent from "react-before-after-slider-component";
import "react-before-after-slider-component/dist/build.css";
import "react-widgets/styles.css";

const Container = styled.div`
    /* Стили для контейнера */
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
`;

const StyledButton = styled.button`
    background-color: #48bb78;
    &:hover {
        background-color: #38a169;
    }
    color: white;
    font-size: 1.5em; /* Default font size for desktop */
    padding: 10px 20px; /* Default padding for desktop */
    border-radius: 5px;
    font-weight: bold;

    @media (max-width: 767px) {
        /* Mobile devices */
        font-size: 1.2em; /* Decrease font size for mobile */
        padding: 8px 16px; /* Decrease padding for mobile */
    }

    @media (min-width: 768px) and (max-width: 1023px) {
        /* Tablets */
        font-size: 1.7em; /* Increase font size for tablets */
        padding: 12px 24px; /* Increase padding for tablets */
    }
`;

const StyledButtonDelete = styled.button`
    background-color: #f44336;
    &:hover {
        background-color: #e53935;
    }
    color: white;
    font-size: 1.5em; /* Default font size for desktop */
    padding: 10px 20px; /* Default padding for desktop */
    border-radius: 5px;
    font-weight: bold;

    @media (max-width: 767px) {
        /* Mobile devices */
        font-size: 1.2em; /* Decrease font size for mobile */
        padding: 8px 16px; /* Decrease padding for mobile */
    }

    @media (min-width: 768px) and (max-width: 1023px) {
        /* Tablets */
        font-size: 1.7em; /* Increase font size for tablets */
        padding: 12px 24px; /* Increase padding for tablets */
    }
`;

const LoaderContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh; // Use the full height of the viewport
    width: 100%; // Use the full width
`;

const StyledMessage = styled.div`
    text-align: center;
    color: #48bb78;
    font-size: 28px;
    margin-bottom: 10px;
`;

const CanvasContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

const zoomButtonStyle = {
    zIndex: 10,
    backgroundColor: "#007bff",
    borderColor: "#007bff",
    color: "white",
    padding: "0.25rem 0.5rem",
    fontSize: "0.875rem",
    lineHeight: 1.5,
    borderRadius: "0.2rem",
    display: "inline-block",
    fontWeight: 400,
    textAlign: "center",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
    cursor: "pointer",
    userSelect: "none",
    border: "1px solid transparent",
    transition:
        "color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
};

const isMobile = window.innerWidth <= 768;

let listModelTable = [
    { id: "0", name: "VGG7" },
    { id: "1", name: "UpConv7" },
    { id: "2", name: "ResNet10" },
    { id: "3", name: "UpResNet10" },
    { id: "5", name: "Optimization" },
];

const StyledInputContainer = styled.div`
    width: 100%;
    margin-bottom: 20px;
`;

const StyledLabel = styled.label`
    display: block;
    font-size: 1.2em;
    margin-bottom: 8px;
    color: #333;
`;

const StyledSelect = styled.select`
    width: 100%;
    padding: 10px;
    font-size: 1em;
    border-radius: 4px;
    border: 1px solid #ccc;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const ImproveImageViewer = (props) => {
    const {
        titleDownload,
        titleDownloadAll,
        titleCopy,
        titleCopied,
        titleDelete,
        titleReady,
        titleCancel,
        titleWidth,
        titleHeight,
        titleImprove,
        titleOriginal,
        titleChooseNecessaryModel,
        titleScaleRatio,
        titleMethod,
        titleNoise,
        titleScale,
        titleNoiseLevel,
        titleTtaLevel,
        titleZoom,
    } = props.attributes;

    const [scaleRatio, setScaleRatio] = useState("2");
    const [method, setMethod] = useState("noise_scale");
    const [noiseLevel, setNoiseLevel] = useState("2");
    const [ttaLevel, setTtaLevel] = useState("4");

    const [isLoading, setIsLoading] = useState(false);
    const [fileId, setfileId] = useState(props.fileId);
    const [fileName, setfileName] = useState(props.fileName);
    const [isProcessingFinished, setIsProcessingFinished] = useState(false);
    const [downloadUrl, setDownloadUrl] = useState(null);
    const [thumbnailUrl, setThumbnailUrl] = useState(null);
    const [downloadFileUrls, setDownloadFileUrls] = useState(null);
    const [isDownloading, setIsDownloading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [showViewer, setShowViewer] = useState(true);
    const [open, setOpen] = useState(false);
    const [model, setModel] = useState(listModelTable[0]); // Установите модель по умолчанию

    const [switchImprove, setSwitchImprove] = useState(false);

    const [firstImageSize, setFirstImageSize] = useState({});
    const [secondImageSize, setSecondImageSize] = useState({});

    const [zoomEnabled, setZoomEnabled] = useState(false);

    const handleZoomToggle = () => {
        setZoomEnabled(!zoomEnabled);
    };

    const zoomStyle = zoomEnabled
        ? { transform: "scale(1.5)", transition: "transform 0.3s" }
        : {};

    useEffect(() => {
        const image1 = new Image();
        image1.onload = () => {
            setFirstImageSize({ width: image1.width, height: image1.height });
        };
        image1.src = props.imageUrl;

        const image2 = new Image();
        image2.onload = () => {
            setSecondImageSize({ width: image2.width, height: image2.height });
        };
        image2.src = downloadUrl;
    }, [props.imageUrl, downloadUrl]);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleModelChange = (value) => {
        setModel(value);
        setOpen(false);
    };

    const canvasRef = useRef(null);
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth * 0.9,
        height: window.innerHeight,
    });

    const [activeTab, setActiveTab] = useState(1);

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
        setSwitchImprove(false);
    };

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth * 0.9,
                height: window.innerHeight,
            });
        };
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setWindowSize({
                width: window.innerWidth * 0.9,
                height: window.innerHeight,
            });
            drawImageProportional();
        };

        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [props.imageUrl]);

    const drawImageProportional = () => {
        const canvas = canvasRef.current;
        if (!canvas) return;

        const ctx = canvas.getContext("2d");
        if (!ctx) return;

        const image = new Image();
        image.src = props.imageUrl;

        const drawImage = () => {
            const canvasWidth = canvas.width;
            const canvasHeight = canvas.height;
            const imageWidth = image.width;
            const imageHeight = image.height;

            const maxImageSize = Math.min(canvasWidth, canvasHeight);
            const scaleFactor =
                maxImageSize / Math.max(imageWidth, imageHeight);

            const scaledWidth = imageWidth * scaleFactor;
            const scaledHeight = imageHeight * scaleFactor;

            const x = (canvasWidth - scaledWidth) / 2;
            const y = (canvasHeight - scaledHeight) / 2;

            ctx.clearRect(0, 0, canvasWidth, canvasHeight);
            ctx.drawImage(image, x, y, scaledWidth, scaledHeight);
        };

        if (image.complete) {
            drawImage();
        } else {
            image.onload = drawImage;
        }
    };

    useEffect(() => {
        if (showViewer) {
            drawImageProportional();
        }
    }, [props.imageUrl, showViewer]);

    const createRequestBody = () => {
        const baseBody = {
            fileid: props.fileId,
            tab: activeTab,
            improve: switchImprove,
        };
    };

    const handleImprove = async (e) => {
        e.preventDefault();
        document.body.scrollIntoView({ behavior: "smooth", block: "start" });

        setIsLoading(true);
        setShowViewer(false);

        const requestBody = {
            fileid: props.fileId,
            model: model.id,
            scale_ratio: scaleRatio,
            method: method,
            noise_level: noiseLevel,
            tta_level: ttaLevel,
        };

        try {
            const timestamp = Date.now();

            const response = await fetch(
                `/api/improveImage?timestamp=${timestamp}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Cache-Control": "no-cache",
                    },
                    body: JSON.stringify(requestBody),
                }
            );

            if (!response.ok) {
                const responseData = await response.json();
                throw new Error(responseData.message);
            }

            const responseData = await response.json();
            setIsProcessingFinished(true);
            setDownloadUrl(responseData.url);
            setThumbnailUrl(responseData.thumbnailUrl);
            setIsLoading(false);
            setIsDownloading(false);
            props.setShowUploader(false);
            document.body.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        } catch (error) {
            setErrorMessage(error.message);
            setIsLoading(false);
            props.setShowUploader(false);
        }
    };

    const handleDownload = (e) => {
        e.stopPropagation();
        setIsDownloading(true);
        setDownloadFileUrls(false);
        props.setShowUploader(false);
        document.body.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const resetDownload = () => {
        setIsDownloading(false);
        setIsProcessingFinished(false);
        setDownloadUrl(null);
        setShowViewer(true);
        props.setShowUploader(true);
    };

    function getFileName(url) {
        return url.substring(url.lastIndexOf("/") + 1);
    }

    const reloadPage = () => {
        setShowViewer(true);
        location.reload();
    };

    const [copiedIndex, setCopiedIndex] = useState(null);

    const handleCopyToClipboard = (fileUrl, index) => {
        navigator.clipboard.writeText(fileUrl);
        setCopiedIndex(index);

        setTimeout(() => {
            setCopiedIndex(null);
        }, 5000);
    };

    const handleDragStart = (e) => {
        e.preventDefault();
    };

    return (
        <Container>
            {showViewer && (
                <>
                    <div>
                        <CanvasContainer>
                            <canvas
                                width={windowSize.width * 0.5}
                                height={windowSize.height * 0.5}
                                ref={canvasRef}
                            />
                        </CanvasContainer>
                        <div
                            style={{
                                textAlign: "center",
                                paddingTop: "20px",
                                width: "100%",
                            }}
                            className="form-group"
                        >
                            <span
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    padding: "20px",
                                    backgroundColor: "lightblue",
                                    color: "darkblue",
                                    fontSize: "1.0em",
                                    borderRadius: "4px",
                                    marginBottom: "20px",
                                }}
                            >
                                <span>{titleChooseNecessaryModel}</span>
                                <div style={{ width: "100%" }}>
                                    <DropdownList
                                        name="chooseNecessaryModel"
                                        data={listModelTable}
                                        dataKey="id"
                                        textField="name"
                                        value={model} // Установка значения по умолчанию
                                        onChange={handleModelChange}
                                    />
                                </div>
                            </span>
                            <StyledInputContainer>
                                <StyledLabel>{titleScaleRatio}</StyledLabel>
                                <StyledSelect
                                    value={scaleRatio}
                                    onChange={(e) =>
                                        setScaleRatio(e.target.value)
                                    }
                                >
                                    <option value="2">2</option>
                                    <option value="4">4</option>
                                </StyledSelect>
                            </StyledInputContainer>
                            <StyledInputContainer>
                                <StyledLabel>{titleMethod}</StyledLabel>
                                <StyledSelect
                                    value={method}
                                    onChange={(e) => setMethod(e.target.value)}
                                >
                                    <option value="noise">{titleNoise}</option>
                                    <option value="scale">{titleScale}</option>
                                    <option value="noise_scale">
                                        {titleNoise} {titleScale}
                                    </option>
                                </StyledSelect>
                            </StyledInputContainer>
                            <StyledInputContainer>
                                <StyledLabel>{titleNoiseLevel}</StyledLabel>
                                <StyledSelect
                                    value={noiseLevel}
                                    onChange={(e) =>
                                        setNoiseLevel(e.target.value)
                                    }
                                >
                                    <option value="0">0</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                </StyledSelect>
                            </StyledInputContainer>
                            <StyledInputContainer>
                                <StyledLabel>{titleTtaLevel}</StyledLabel>
                                <StyledSelect
                                    value={ttaLevel}
                                    onChange={(e) =>
                                        setTtaLevel(e.target.value)
                                    }
                                >
                                    <option value="2">2</option>
                                    <option value="4">4</option>
                                    <option value="8">8</option>
                                </StyledSelect>
                            </StyledInputContainer>
                        </div>
                        <div className="px-4 py-2 flex justify-center">
                            <ButtonContainer>
                                <StyledButton onClick={handleImprove}>
                                    {titleImprove}
                                </StyledButton>
                            </ButtonContainer>
                        </div>
                    </div>
                </>
            )}
            {errorMessage && (
                <div>
                    <div className="px-4 py-2">
                        <div
                            className="w-full flex items-center bg-red-500 text-white text-sm font-bold px-4 py-3"
                            role="alert"
                        >
                            {errorMessage}
                        </div>
                    </div>
                    <div className="px-4 py-2">
                        <ButtonContainer>
                            <StyledButton onClick={reloadPage}>
                                {titleCancel}
                            </StyledButton>
                        </ButtonContainer>
                    </div>
                </div>
            )}
            {isLoading && (
                <LoaderContainer>
                    <RingLoader
                        color={"#123abc"}
                        loading={isLoading}
                        size={150}
                    />
                </LoaderContainer>
            )}
            {isProcessingFinished && !isDownloading && (
                <div>
                    <StyledMessage>{titleReady}</StyledMessage>

                    <ButtonContainer>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}
                        >
                            <button
                                onClick={handleZoomToggle}
                                style={{
                                    ...zoomButtonStyle,
                                    display: "flex",
                                    alignItems: "center",
                                }}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    strokeWidth={1.5}
                                    stroke="currentColor"
                                    className="w-6 h-6"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607zM10.5 7.5v6m3-3h-6"
                                    />
                                </svg>
                                {titleZoom}
                            </button>

                            <div
                                onDragStart={handleDragStart}
                                style={{
                                    position: "relative",
                                    ...zoomStyle,
                                    cursor: "pointer",
                                }}
                            >
                                <ReactBeforeSliderComponent
                                    firstImage={{ imageUrl: props.imageUrl }}
                                    secondImage={{ imageUrl: downloadUrl }}
                                />
                                <div
                                    style={{
                                        position: "absolute",
                                        top: "0",
                                        bottom: "0",
                                        left: "0",
                                        width: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "white",
                                        fontWeight: "bold",
                                        textShadow:
                                            "2px 2px 0 black, -2px -2px 0 black, 2px -2px 0 black, -2px 2px 0 black",
                                        pointerEvents: "none",
                                    }}
                                >
                                    {titleImprove} -{" "}
                                    <span>{`${secondImageSize.width}x${secondImageSize.height}`}</span>
                                </div>
                                <div
                                    style={{
                                        position: "absolute",
                                        top: "0",
                                        bottom: "0",
                                        right: "0",
                                        width: "50%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "white",
                                        fontWeight: "bold",
                                        textShadow:
                                            "2px 2px 0 black, -2px -2px 0 black, 2px -2px 0 black, -2px 2px 0 black",
                                        pointerEvents: "none",
                                    }}
                                >
                                    {titleOriginal} -{" "}
                                    <span>{`${firstImageSize.width}x${firstImageSize.height}`}</span>
                                </div>
                            </div>
                            <div className="pt-2" style={{ display: "flex" }}>
                                <ImageSize
                                    src={thumbnailUrl}
                                    attributes={props.attributes}
                                />
                            </div>
                            <div className="pt-2" style={{ display: "flex" }}>
                                <a
                                    href={downloadUrl}
                                    download={getFileName(downloadUrl)}
                                    onClick={handleDownload}
                                >
                                    <StyledButton>{titleDownload}</StyledButton>
                                </a>
                                <a className="pl-2" onClick={handleDownload}>
                                    <StyledButtonDelete>
                                        {titleDelete}
                                    </StyledButtonDelete>
                                </a>
                            </div>
                        </div>
                    </ButtonContainer>
                </div>
            )}
            {isDownloading && (
                <div>
                    <ButtonContainer>
                        <StyledButton onClick={resetDownload}>
                            {titleCancel}
                        </StyledButton>
                    </ButtonContainer>
                </div>
            )}
        </Container>
    );
};

export default ImproveImageViewer;
